import { render, staticRenderFns } from "./DuplicateContacts.vue?vue&type=template&id=043265cc&scoped=true"
import script from "./DuplicateContacts.vue?vue&type=script&lang=js"
export * from "./DuplicateContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043265cc",
  null
  
)

export default component.exports